module.exports = __webpack_public_path__ + "static/our-classes-4-686aa40687d875435d64aebc0dc72cbc.jpg";